import {
  truncate, isEmpty, size, first, split, startsWith, isNil,
} from 'lodash';

/**
 * Contrôle de la validité de l'identifiant
 * @memberof TiersFicheControlesMetier
*/
const controleCleLuhn = (identifiant) => {
  const identifiantLaPoste = (truncate(identifiant, { length: 9 }) === '356000000');

  let somme = 0;
  let chiffre = 0;
  let pair = false;

  for (let n = identifiant.length - 1; n >= 0; n--) {
    chiffre = parseInt(identifiant.charAt(n), 10);

    if (pair && !identifiantLaPoste) {
      chiffre *= 2;
      if (chiffre > 9) {
        chiffre -= 9;
      }
    }

    somme += chiffre;
    pair = !pair;
  }

  if (identifiantLaPoste) {
    return (somme % 5) === 0;
  }

  return (somme % 10) === 0;
};

/**
 * Contrôles front de la saisie du champ identifiant
 *
 * @memberof TiersFicheControlesMetier
*/
export const controleIdentification = (identification, natureIdentification) => {
  if (!isEmpty(natureIdentification)) {
    switch (natureIdentification) {
      case '01 SIRET':
        if (size(identification) !== 14) {
          return {
            message: `La longueur d'un siret doit être de 14 caractères.\n(saisie : ${size(identification)})`,
            type: 'error',
          };
        }

        if (!controleCleLuhn(identification)) {
          return {
            message: 'L\'identifiant est invalide (clé Luhn).',
            type: 'error',
          };
        }

        break;
      case '02 SIREN':
        if (size(identification) !== 9) {
          return {
            message: `La longueur d'un siren doit être de 9 caractères.\n(saisie : ${size(identification)})`,
            type: 'error',
          };
        }

        if (!controleCleLuhn(identification)) {
          return {
            message: 'L\'identifiant est invalide (clé Luhn)',
            type: 'error',
          };
        }

        break;
      case '04 NIR':
        if (size(identification) !== 15) {
          return {
            message: 'La longueur d\'un NIR doit être de 15 caractères',
            type: 'error',
          };
        }

        break;
      default: break;
    }
  }

  return null;
};

export const controleNatureIdentification = (natureIdentification, identification, natureJuridiquePes) => {
  if (!isEmpty(natureIdentification)) {
    if (first(split(natureJuridiquePes, ' ')) === '01') {
      return {
        message: 'Un particulier ne doit pas avoir d\'identifiant',
        type: 'error',
      };
    }

    if (isEmpty(identification)) {
      return {
        message: 'Un identifiant doit être renseigné',
        type: 'error',
      };
    }
  } else if (!isEmpty(identification)) {
    return {
      message: "La nature identifiant doit être renseignée si l'identifiant l'est",
      type: 'error',
    };
  }

  return null;
};

/**
 * Contrôles front de la saisie de la fiche tiers
 *
 * @memberof TiersFicheControlesMetier
*/
export const controleSaisie = (tiers) => {
  const {
    categoriePes,
    nom,
    identifiantCivilite,
    prenom,
    natureJuridiquePes,
    identification,
    natureIdentification,
  } = tiers || {};
  const personnePhysique = startsWith(categoriePes, '01');

  const erreurs = [];

  if (personnePhysique) {
    if (isNil(nom) || isEmpty(nom)) {
      erreurs.push({
        id: 'Identification-nom',
        message: 'Le nom est obligatoire',
      });
    }

    if (isNil(identifiantCivilite)) {
      erreurs.push({
        id: 'Identification-civilite',
        message: 'Si le tiers est une personne physique, la civilité est obligatoire',
      });
    }

    if (isNil(prenom) || isEmpty(prenom)) {
      erreurs.push({
        id: 'Identification-prenom',
        message: 'Si le tiers est une personne physique, le prénom est obligatoire',
      });
    }
  } else if (isNil(nom) || isEmpty(nom)) {
    erreurs.push({
      id: 'Identification-nom',
      message: 'La raison sociale est obligatoire',
    });
  }

  if (
    isNil(natureJuridiquePes)
        || isEmpty(categoriePes)
        || isEmpty(natureJuridiquePes)
        || isNil(categoriePes)
  ) {
    erreurs.push({
      id: 'Identification-natureJuridiquePes/categoriePes',
      message: 'Le couple nature juridique PES / catégorie PES est obligatoire.',
    });
  }

  const controleIdentNatCat = controleIdentification(
    identification,
    natureIdentification,
  );

  if (!isNil(controleIdentNatCat)) {
    erreurs.push({
      id: 'Identification-identification',
      message: controleIdentNatCat.message,
    });
  }

  const controleNatIdent = controleNatureIdentification(
    natureIdentification,
    identification,
    '',
  );

  if (!isNil(controleNatIdent)) {
    erreurs.push({
      id: 'Identification-natureIdentification',
      message: controleNatIdent.message,
    });
  }

  return erreurs;
};
